











import GIFGroover from "@/app/shared/utils/GIFGroover.js";

export default {
  name: "BaseGifPlayer",
  mixins: [GIFGroover],
  data() {
    return {
      loaded: false,
      gifObject: null,
    };
  },
  props: {
    src: {
      type: String,
      required: true,
    },
    paused: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    currentTime: {
      get: function () {
        return this.gifObject.currentTime
          ? this.gifObject.currentTime / 1000
          : 0;
      },
      set: function (time: number) {
        if (this.loaded) {
          this.gifObject.seek(time);
        }
      },
    },
    duration: function () {
      return this.gifObject.duration;
    },
  },
  watch: {
    paused: function () {
      if (this.paused) {
        this.gifObject.pause();
      } else {
        this.gifObject.play();
      }
    },
  },
  beforeMount() {
    this.gifObject = this.GIFGroover();
    this.gifObject.src = this.src;
    this.gifObject.onload = this.gifLoad;
  },
  methods: {
    gifLoad(event) {
      this.loaded = true;
      const gif = event.gif;
      const canvas = this.$refs.gifCanvas;
      canvas.width = gif.width;
      canvas.height = gif.height;
      this.currentTime = 0;

      requestAnimationFrame(this.renderer);
      setTimeout(() => {
        if (this.paused) {
          this.gifObject.pause();
        } else {
          this.gifObject.play();
        }
      }, 200);
    },
    renderer() {
      const canvas = this.$refs.gifCanvas;
      if (!canvas) {
        return;
      }
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(this.gifObject.image, 0, 0, canvas.width, canvas.height);

      requestAnimationFrame(this.renderer);
    },
  },
};
